// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { maybe } from "@altostra/type-validations";
import { maybeBoolean, maybeString, maybeNumber } from "@altostra/type-validations/lib/primitives";

import type { InboxVisionCreateEmailTestResult } from "./types";

export const isInboxVisionCreateEmailTestResult = objectOf<InboxVisionCreateEmailTestResult>({
  email_test_id: maybeString,
  retried: maybeBoolean,
  user_id: maybeString,
  aborted: maybeBoolean,
  abort_message: maybeString,
  warn: maybeString,
  warn_header: maybeString,
  limits: maybe(
    objectOf({
      curr: maybeNumber,
      max: maybeNumber,
    })
  ),
});
